import joinPath from 'lib/join-path'
import { ROADS } from './slides/path-to-parenthood'
import { ARRIVAL_AGE_PATH } from './slides/adoption'
import { MILESTONE_PATH } from './slides/pregnancy'

export const PATHS = {
  BASE: '/registry/new',
  ROAD_AHEAD: '/',
  SENTIMENT: '/sentiment',
  SIGNUP: '/signup',
  ADD_ITEMS_VALUE_PROPOSITION: '/items-from-any-store',
  FINISHING_TOUCHES: '/finishing-touches',
  ADD_PARTNER: '/add-partner',
  ADD_BUTTON: '/add-button',
  INSTALL_EXTENSION: '/install-extension',
  INSTALL_APP: '/install-app',
  FINISH_SIGNUP: '/finish-signup',
  FIRST_TIME_PARENT: '/first-time-parent',
  ACCEPT_INVITE: '/accept-invite',
  POST_INSTALL_EXTENSION: '/try-it-out',
  ACT_EX1_ONBOARDING_PRIMER: '/get-started',
  ADD_ITEMS_EXPERIENCE: '/add-items-experience',
}

export const ONBOARDING_STEPS = {
  BEFORE_LOADING: 0,
  PATH_TO_PARENTHOOD_1: 1,
  PATH_TO_PARENTHOOD_2: 2,
  // Still Trying will skip step 3
  PATH_TO_PARENTHOOD_3: 3,
  FIRST_TIME_PARENT: 4,
  SENTIMENT: 5,
  SIGNUP: 6,
  POST_SIGNUP: 7,
}

export const ONBOARDING_STEP_PATHS = {
  [PATHS.ROAD_AHEAD]: ONBOARDING_STEPS.PATH_TO_PARENTHOOD_1,
  [ROADS.PREGNANCY.path]: ONBOARDING_STEPS.PATH_TO_PARENTHOOD_2,
  [ROADS.SURROGACY.path]: ONBOARDING_STEPS.PATH_TO_PARENTHOOD_2,
  [ROADS.ADOPTION.path]: ONBOARDING_STEPS.PATH_TO_PARENTHOOD_2,
  [ROADS.STILL_TRYING.path]: ONBOARDING_STEPS.PATH_TO_PARENTHOOD_2,
  [joinPath(ROADS.ADOPTION.path, ARRIVAL_AGE_PATH)]:
    ONBOARDING_STEPS.PATH_TO_PARENTHOOD_3,
  [joinPath(ROADS.PREGNANCY.path, MILESTONE_PATH)]:
    ONBOARDING_STEPS.PATH_TO_PARENTHOOD_3,
  [joinPath(ROADS.SURROGACY.path, MILESTONE_PATH)]:
    ONBOARDING_STEPS.PATH_TO_PARENTHOOD_3,
  [PATHS.FIRST_TIME_PARENT]: ONBOARDING_STEPS.FIRST_TIME_PARENT,
  [PATHS.SENTIMENT]: ONBOARDING_STEPS.SENTIMENT,
  [PATHS.SIGNUP]: ONBOARDING_STEPS.SIGNUP,
  [PATHS.FINISHING_TOUCHES]: ONBOARDING_STEPS.POST_SIGNUP,
  [PATHS.ADD_PARTNER]: ONBOARDING_STEPS.POST_SIGNUP,
  [PATHS.ADD_BUTTON]: ONBOARDING_STEPS.POST_SIGNUP,
}

export const SHOW_BACKGROUND_PATHS = [
  ...Object.keys(ONBOARDING_STEP_PATHS),
  PATHS.ADD_ITEMS_EXPERIENCE,
  PATHS.ACCEPT_INVITE,
]

export const SHOW_PLAIN_BACKGROUND_PATHS = [
  PATHS.INSTALL_EXTENSION,
  PATHS.POST_INSTALL_EXTENSION,
]

export const HIDE_HEADER_PATHS = [
  ROADS.PREGNANCY.path,
  ROADS.SURROGACY.path,
  ROADS.ADOPTION.path,
  ROADS.STILL_TRYING.path,
  joinPath(ROADS.PREGNANCY.path, MILESTONE_PATH),
  joinPath(ROADS.SURROGACY.path, MILESTONE_PATH),
  PATHS.ACT_EX1_ONBOARDING_PRIMER,
  PATHS.ADD_ITEMS_EXPERIENCE,
]
